import { useEffect, useSyncExternalStore } from 'react';

// ==============================|| BREADCRUMBS — EXTRA CRUMBS (store) ||============================== //
// Breadcrumb-urile se derivă din pathname, dar vederile deschise prin query-string
// (ex. detaliul de proiect, /common/project?view=<id>) nu apar în path. Paginile pot
// publica aici crumb-uri suplimentare (ex. numele proiectului) care se adaugă la
// finalul traseului — REV-NAV-01.

export interface BreadcrumbExtra {
	label: string;
	// calea (poate include query-string); ultimul crumb se randează fără link oricum
	path: string;
}

let extras: BreadcrumbExtra[] = [];
const listeners = new Set<() => void>();

function setBreadcrumbExtras(next: BreadcrumbExtra[]): void {
	extras = next;
	listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

function getSnapshot(): BreadcrumbExtra[] {
	return extras;
}

export function useBreadcrumbExtras(): BreadcrumbExtra[] {
	return useSyncExternalStore(subscribe, getSnapshot);
}

// hook de pagină: publică crumb-ul cât timp componenta e montată, apoi îl curăță
export function useBreadcrumbExtra(extra: BreadcrumbExtra | null): void {
	const label = extra?.label ?? null;
	const path = extra?.path ?? null;
	useEffect(() => {
		if (label == null || path == null) return undefined;
		setBreadcrumbExtras([{ label, path }]);
		return () => setBreadcrumbExtras([]);
	}, [label, path]);
}
